import {useI18n} from '@yandex-delivery/core/i18n'
import {useMemo} from 'react'
import {useWatch} from 'react-hook-form'

import type {Props} from './Contact.types'

export function useContact({name, isSource}: Props) {
  const i18n = useI18n()
  const names = {
    phone: `${name}.phone`,
    name: `${name}.name`,
    sms: `${name}.notifications`,
  }
  const contact = useWatch({name: names.phone})

  const labelPhone = useMemo(() => {
    if (isSource) {
      if (!contact) {
        return i18n('bdui.address.input.sender_phone_choose', 'Телефон отправителя *')
      }

      return i18n('bdui.address.input.sender_phone', 'Телефон отправителя')
    }

    if (!contact) {
      return i18n('bdui.address.input.recipient_phone_choose', 'Телефон получателя *')
    }

    return i18n('bdui.address.input.recipient_phone', 'Телефон получателя')
  }, [isSource, contact, i18n])

  return {
    labelPhone,
    labelName: isSource
      ? i18n('bdui.address.input.sender_name', 'Имя отправителя')
      : i18n('bdui.address.input.recipient_name', 'Имя получателя'),
    names,
    isSource,
    smsTitle: i18n('bdui.address.switch.notifications_title', 'СМС подтверждение'),
    smsSubtitle: i18n('bdui.address.switch.notifications_subtitle', 'передачи посылки курьеру'),
  } as const
}
